<template>
	<ViewFeedItem class="view-feed-whatsyourout">
		<template v-slot:header>
			<ViewLayoutModuleHeader title="What's your out?">
				<!-- <RouterLink v-bind:to="{ name: 'PagePlaces' }">
					<strong>View All</strong>
				</RouterLink> -->
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<section>
				<figure>
					<ViewUiMediaZoomableImage
						v-bind:initialScale="1.0"
						v-bind:maxScale="5.0"
						v-bind:minScale="0.5"
						v-bind:src="imageUrl"
					/>

					<figcaption>
						<p>
							Voice your opinion on the best way to get out of this rack, or when it&rsquo;s time to play
							safe.
						</p>
						<small>Changes daily</small>
					</figcaption>
				</figure>
			</section>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * This module is having a scrolling issue on desktop due to zoomable image wheel capture.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedWhatsYourOut extends ViewBase {
		/**
		 * @type string
		 */
		protected get diagramUrl(): string {
			return 'https://pad.chalkysticks.com/595b7';
		}

		/**
		 * @type string
		 */
		protected get imageUrl(): string {
			return this.diagramUrl + '.svg';
		}
	}
</script>

<style lang="scss">
	.view-feed-whatsyourout {
		.body {
			padding: 0 var(--padding);
		}

		figcaption {
			padding: 1em 0;
		}
	}
</style>
